import { useStyles } from "./dashboard-list-styles";
import { CardDashboardSincronizacao } from "../../../../../components/cards/card-dashboard-sincronizacao/card-dashboard-sincronizacao";
import { CardDashboardPedido } from "../../../../../components/cards/card-dashboard-pedido/card-dashboard-pedido";

export const DashboardList = () => {
  const classes = useStyles();

  return (
    <div className={classes.defaultContainer}>
      <CardDashboardSincronizacao />
      <CardDashboardPedido />
    </div>
  );
};
